import { canAdmin, canManagePayroll } from '@webapp-next/lib/facades';
import userHasPermission from '@webapp-next/lib/user-has-permission';
import { PAYROLL_PERMISSIONS } from '@apps-payroll/definitions';
import { checkPayrollAdvancedPermissionEnabled } from '@apps-payroll/utils/feature-flags';

export function checkPayrollPermissions(): {
  hasAddBusinessEntityPermission: boolean;
  hasEditBusinessEntityPermission: boolean;
  hasViewBusinessEntityPermission: boolean;
  hasViewPayBusinessSettingsPermission: boolean;
  hasViewPayCalendarPermission: boolean;
  hasManagePayCalendarPermission: boolean;
  hasManagePayDetailsPermission: boolean;
  hasManagePayrollDetailsPermission: boolean;
  hasSetupInitialPayrollPermission: boolean;
} {
  const isPayrollAdvancedPermissionEnabled = checkPayrollAdvancedPermissionEnabled();

  const hasManagePayDetailsPermission = userHasPermission(
    PAYROLL_PERMISSIONS.Can_Manage_Employee_PayDetails
  );

  if (isPayrollAdvancedPermissionEnabled) {
    const hasAddBusinessEntityPermission = userHasPermission(
      PAYROLL_PERMISSIONS.Can_Add_Business_Entity
    );
    const hasEditBusinessEntityPermission = userHasPermission(
      PAYROLL_PERMISSIONS.Can_Edit_Business_Entity
    );
    const hasViewBusinessEntityPermission =
      hasAddBusinessEntityPermission || hasEditBusinessEntityPermission;

    return {
      hasAddBusinessEntityPermission,
      hasEditBusinessEntityPermission,
      hasViewBusinessEntityPermission,
      hasViewPayBusinessSettingsPermission: userHasPermission(
        PAYROLL_PERMISSIONS.Can_View_Pay_Business_Setting
      ),
      hasViewPayCalendarPermission: userHasPermission(
        PAYROLL_PERMISSIONS.Can_View_Pay_Calendar
      ),
      hasManagePayCalendarPermission: userHasPermission(
        PAYROLL_PERMISSIONS.Can_Manage_Pay_Calendar
      ),
      hasManagePayDetailsPermission,
      hasManagePayrollDetailsPermission: userHasPermission(
        PAYROLL_PERMISSIONS.Can_Manage_Emp_Payroll_Details
      ),
      hasSetupInitialPayrollPermission: userHasPermission(
        PAYROLL_PERMISSIONS.Can_Setup_Initial_Payroll
      ),
    };
  }

  return {
    hasAddBusinessEntityPermission: canAdmin(),
    hasEditBusinessEntityPermission: canAdmin(),
    hasViewBusinessEntityPermission: true,
    hasViewPayBusinessSettingsPermission: canManagePayroll(),
    hasViewPayCalendarPermission: true,
    hasManagePayCalendarPermission: true,
    hasManagePayDetailsPermission,
    hasManagePayrollDetailsPermission: canManagePayroll(),
    hasSetupInitialPayrollPermission: canAdmin(),
  };
}
